<template>
  <div class="GlobalFormDemo">
    <GlobalForm
      :init-data="initData"
      :form-item-list="formItemList"
      :inline="true"
      :labelWidth="80"
      :needBtnLoading="true"
      round
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
      <el-form-item label="操作人" slot="optName" label-width="70px">
        <el-select v-model="operatorName" filterable clearable placeholder="请输入名称查询">
          <el-option
            v-for="item in staffList"
            :key="item.operatorAccount"
            :label="item.operatorName"
            :value="item.operatorAccount"
          />
        </el-select>
      </el-form-item>
    </GlobalForm>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
export default {
  name: "Form",
  data() {
    const that = this;
    return {
      operatorName: "",
      staffList: [],
      pickerMinDate: 0,
      initData: {
        entryTime: [
          moment().subtract(6, "days").format("YYYY-MM-DD 00:00:00"),
          moment().format("YYYY-MM-DD 23:59:59"),
        ],
      },
      formItemList: [
        {
          key: "taskNo",
          type: "input",
          labelName: "任务单号",
          placeholder: "请输入任务单号查询",
          lableWidth: "80px",
        },
        { slotName: "optName" },
        {
          key: "entryTime",
          type: "pickerOptions",
          labelName: "添加时间",
          lableWidth: "80px",
          placeholder: "请选择添加时间",
          valueFormat: "timestamp",
          clearable: true,
          pickerOptions: {
            onPick: ({ maxDate, minDate }) => {
              if (minDate) {
                that.pickerMinDate = minDate.getTime();
              }
              if (maxDate) {
                that.pickerMinDate = 0;
              }
            },
            disabledDate: (time) => {
              if (that.pickerMinDate) {
                const day31 = 31 * 24 * 60 * 60 * 1000;
                const minTime = that.pickerMinDate - day31;
                const maxTime = that.pickerMinDate + day31;
                return time.getTime() < minTime || time.getTime() > maxTime;
              }
              return false;
            },
          },
        },
      ],
    };
  },
  created() {
    this.getStaffList();
    this.handleConfirm(this.initData);
  },
  methods: {
    getStaffList() {
      _api.operatorList().then((res) => {
        this.staffList = res.data;
      });
    },
    handleConfirm(data, cd) {
      let startTime = "";
      let endTime = "";
      if (data.entryTime === null) {
        startTime = "";
        endTime = "";
      } else {
        startTime = Number(moment(data.entryTime[0]).format("x"));
        endTime = Number(moment(data.entryTime[1]).format("x"));
      }
      const SeachParams = {
        taskNo: data && data.taskNo ? data.taskNo : "",
        optAccount: this.operatorName,
        startTime,
        endTime,
        pageNum: 1,
        pageSize: 10,
        disuseLoding: () => {
          if (typeof cd === "function") {
            cd();
          }
        },
      };
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
  },
};
</script>
